/* PROMOCOLOUR — Product Quote Wizard engine
   Reads live Shopify variants, applies tier discounts, drives the 4 steps,
   and adds to cart (with the quote captured as line-item properties). */
(function () {
  function init(root) {
    if (!root || root.__pwInit) return;
    root.__pwInit = true;

    // Core controls the pricing engine depends on — if markup ever drifts, no-op instead of throwing.
    if (!root.querySelector('[data-pw-qty]') || !root.querySelector('[data-pw-unit]') || !root.querySelector('[data-pw-option]')) return;

    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    /* ---- data ---- */
    function parseJSON(sel, fallback) {
      var el = $(sel); if (!el) return fallback;
      try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
    }
    var variants = parseJSON('[data-pw-variants]', []);
    var meta = parseJSON('[data-pw-meta]', {});
    var tiers = [];
    try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) { tiers = []; }
    tiers.sort(function (a, b) { return b.min - a.min; }); // highest first

    var shipping = parseFloat(root.getAttribute('data-shipping')) || 0;
    var gstIncluded = root.getAttribute('data-gst-included') === 'true';
    var GST_RATE = 0.10;

    var artMethod = (function () { var a = $('[data-pw-uptab].is-active'); return a ? a.getAttribute('data-pw-method') : 'Print-ready files'; })();

    /* ---- helpers ---- */
    function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }

    function selectedValues() {
      return $$('[data-pw-option]').map(function (s) { return s.value; });
    }

    function currentVariant() {
      var vals = selectedValues();
      return variants.find(function (v) {
        var opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
        return vals.every(function (val, i) { return opts[i] === val; });
      }) || variants[0];
    }

    function tierFor(qty) {
      for (var i = 0; i < tiers.length; i++) { if (qty >= tiers[i].min) return tiers[i]; }
      return { min: 1, pct: 0 };
    }
    function nextTier(qty) {
      // tiers sorted desc; find the smallest min greater than qty
      var asc = tiers.slice().sort(function (a, b) { return a.min - b.min; });
      for (var i = 0; i < asc.length; i++) { if (asc[i].min > qty) return asc[i]; }
      return null;
    }

    function pricing() {
      var v = currentVariant();
      var unit = (v && typeof v.price === 'number' ? v.price : 0) / 100; // Shopify variant price = cents
      var qty = Math.max(1, parseInt($('[data-pw-qty]').value, 10) || 1);
      var t = tierFor(qty);
      var discUnit = unit * (1 - t.pct / 100);
      var subtotal = discUnit * qty;
      var ship = shipping;
      var gst, total;
      if (gstIncluded) { total = subtotal + ship; gst = total - (total / (1 + GST_RATE)); }
      else { gst = (subtotal + ship) * GST_RATE; total = subtotal + ship + gst; }
      return { v: v, unit: unit, qty: qty, tier: t, discUnit: discUnit, subtotal: subtotal, ship: ship, gst: gst, total: total };
    }

    /* ---- render: price + ladder + nudge ---- */
    function renderPrice() {
      var p = pricing();
      var vid = $('[data-pw-vid]'); if (vid) vid.value = p.v.id; // keep the form's variant id in sync for UploadLift
      $('[data-pw-unit]').textContent = money(p.discUnit);
      var stickyPrice = $('[data-pw-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = 'from ' + money(p.discUnit) + ' /each';
      var off = $('[data-pw-off]');
      if (p.tier.pct > 0) { off.hidden = false; off.textContent = p.tier.pct + '% OFF applied'; }
      else { off.hidden = true; }

      // ladder
      var ladder = $('[data-pw-ladder]');
      ladder.innerHTML = tiers.slice().sort(function (a, b) { return a.min - b.min; }).map(function (t) {
        var active = p.qty >= t.min && p.tier.min === t.min;
        return '<button type="button" class="pc-pw__rung' + (active ? ' is-active' : '') + '" data-pw-rung="' + t.min + '">' +
          '<span class="pc-pw__rq">' + t.min + '+</span><span class="pc-pw__rd">' + t.pct + '% off</span></button>';
      }).join('');
      $$('[data-pw-rung]', ladder).forEach(function (b) {
        b.addEventListener('click', function () { $('[data-pw-qty]').value = b.getAttribute('data-pw-rung'); renderPrice(); });
      });

      // nudge
      var nudge = $('[data-pw-nudge]');
      var nt = nextTier(p.qty);
      if (nt) { nudge.hidden = false; nudge.innerHTML = '↑ Add ' + (nt.min - p.qty) + ' more to reach ' + nt.min + '+ and save ' + nt.pct + '%'; }
      else { nudge.hidden = true; }

      // update CTA total if present
      var submit = $('[data-pw-submit]');
      if (submit) submit.setAttribute('data-total', money(p.total));
    }

    /* ---- step navigation ---- */
    function goTo(step) {
      $$('[data-pw-panel]').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-pw-panel') === String(step));
      });
      $$('[data-pw-stepdot]').forEach(function (dot) {
        var n = parseInt(dot.getAttribute('data-pw-stepdot'), 10);
        dot.classList.toggle('is-active', n === step);
        if (n === step) { dot.setAttribute('aria-current', 'step'); } else { dot.removeAttribute('aria-current'); }
        dot.classList.toggle('is-done', n < step);
        dot.querySelector('.pc-pw__num').textContent = n < step ? '✓' : n;
      });
      var stepper = $('[data-pw-stepper]');
      if (stepper) stepper.setAttribute('data-step', step);
      if (step === 2) renderQuote();
      if (step === 4) renderSummary();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* ---- step 2: quote table ---- */
    function specRows() {
      var rows = $$('[data-pw-option]').map(function (s) {
        var name = s.closest('.pc-pw__field').querySelector('label').textContent;
        return ['<div class="pc-pw__qrow"><span class="l">' + name + '</span><span class="v">' + s.value + '</span></div>'].join('');
      });
      rows.push('<div class="pc-pw__qrow"><span class="l">Quantity</span><span class="v">' + pricing().qty + ' units</span></div>');
      rows.push('<div class="pc-pw__qrow"><span class="l">Artwork</span><span class="v">' + (artMethod || '—') + '</span></div>');
      return rows.join('');
    }
    function renderQuote() {
      var p = pricing();
      var html = '<div class="pc-pw__qrows">' + specRows() +
        '<div class="pc-pw__qrow price"><span class="l">Price per item' + (p.tier.pct ? ' (' + p.tier.pct + '% off)' : '') + '</span><span class="v">' + money(p.discUnit) + '</span></div>' +
        '<div class="pc-pw__qrow price"><span class="l">Subtotal</span><span class="v">' + money(p.subtotal) + '</span></div>' +
        '<div class="pc-pw__qrow price"><span class="l">Shipping (flat rate)</span><span class="v">' + money(p.ship) + '</span></div>' +
        '<div class="pc-pw__qrow price"><span class="l">GST</span><span class="v">' + money(p.gst) + '</span></div>' +
        '<div class="pc-pw__qrow total"><span class="l">Total</span><span class="v">' + money(p.total) + ' <small>inc GST</small></span></div></div>';
      $('[data-pw-quote-table]').innerHTML = html;
    }

    /* ---- step 4: summary ---- */
    function renderSummary() {
      var p = pricing();
      var opts = selectedValues().join(' · ');
      $('[data-pw-summary]').innerHTML =
        '<div class="pc-pw__sum-top">' + (meta.featured ? '<img src="' + meta.featured + '" alt="">' : '') +
        '<div><b>' + (meta.title || 'Product') + '</b><br><span>' + opts + ' · ×' + p.qty + '</span></div></div>' +
        '<div class="pc-pw__sum-rows">' +
        '<div class="r"><span>Subtotal' + (p.tier.pct ? ' (' + p.tier.pct + '% off)' : '') + '</span><span>' + money(p.subtotal) + '</span></div>' +
        '<div class="r"><span>Shipping</span><span>' + money(p.ship) + '</span></div>' +
        '<div class="r"><span>GST</span><span>' + money(p.gst) + '</span></div>' +
        '<div class="r tot"><span><b>Total</b></span><b>' + money(p.total) + ' inc GST</b></div></div>';
    }

    /* ---- branded quote document (opens in a new tab; Save-as-PDF via print) ---- */
    function quoteHTML() {
      var p = pricing();
      var acc = meta.accent || '#17A34A';
      var brand = meta.shop || 'Promocolour';
      var rows = '';
      selectedValues().forEach(function (v, i) {
        var label = $$('[data-pw-option]')[i].closest('.pc-pw__field').querySelector('label').textContent;
        rows += '<tr><td>' + label + '</td><td>' + v + '</td></tr>';
      });
      rows += '<tr><td>Quantity</td><td>' + p.qty + ' units</td></tr>';
      rows += '<tr><td>Artwork</td><td>' + (artMethod || '—') + '</td></tr>';
      var pr =
        '<tr><td>Price per item' + (p.tier.pct ? ' <span class="pill">' + p.tier.pct + '% off</span>' : '') + '</td><td>' + money(p.discUnit) + '</td></tr>' +
        '<tr><td>Subtotal</td><td>' + money(p.subtotal) + '</td></tr>' +
        '<tr><td>Shipping (flat rate)</td><td>' + money(p.ship) + '</td></tr>' +
        '<tr><td>GST</td><td>' + money(p.gst) + '</td></tr>';
      var logo = meta.logo ? '<img class="logo" src="' + meta.logo + '" alt="' + brand + '">' : '<div class="wm">promo<span>colour</span></div>';
      var dateStr = new Date().toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });
      var dlfile = 'Promocolour-quote-' + ((meta.title || 'product').replace(/[^a-z0-9]+/gi, '-').toLowerCase().replace(/^-|-$/g, '')) + '.html';
      var absUrl = meta.url ? (location.origin + meta.url) : '';
      return '<!doctype html><html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">' +
        '<title>Quote — ' + (meta.title || '') + ' · ' + brand + '</title><style>' +
        '@import url("https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;700;800&display=swap");' +
        ':root{--acc:' + acc + '}*{box-sizing:border-box}' +
        'body{font-family:Figtree,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif;color:#16181D;margin:0;background:#f4f6f7;-webkit-print-color-adjust:exact;print-color-adjust:exact}' +
        '.sheet{max-width:720px;margin:32px auto;background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 10px 40px rgba(0,0,0,.08)}' +
        '.bar{height:6px;background:var(--acc)}' +
        '.head{display:flex;justify-content:space-between;align-items:flex-start;padding:30px 40px 0}' +
        '.logo{height:40px;width:auto}.wm{font-size:24px;font-weight:800;letter-spacing:-.02em}.wm span{color:var(--acc)}' +
        '.m{text-align:right;font-size:12px;color:#5B6470;line-height:1.7}' +
        '.ey{color:var(--acc);font-weight:800;letter-spacing:.14em;text-transform:uppercase;font-size:12px;margin:26px 40px 0}' +
        'h1{font-size:28px;font-weight:800;letter-spacing:-.02em;margin:4px 40px 0;line-height:1.1}' +
        '.sub{margin:6px 40px 0;color:#5B6470;font-size:13px;word-break:break-all}' +
        'table{width:calc(100% - 80px);margin:22px 40px 0;border-collapse:collapse}' +
        'td{padding:12px 0;border-bottom:1px solid #EFF1F3;font-size:14px}td:first-child{color:#5B6470}td:last-child{text-align:right;font-weight:600}' +
        '.pill{display:inline-block;background:rgba(23,163,74,.1);color:var(--acc);font-size:11px;font-weight:700;padding:2px 8px;border-radius:100px;margin-left:6px}' +
        '.tot{margin:22px 40px 0;background:#16181D;color:#fff;border-radius:12px;padding:18px 22px;display:flex;justify-content:space-between;align-items:center}' +
        '.tot .l{font-size:12px;color:rgba(255,255,255,.7);text-transform:uppercase;letter-spacing:.08em}.tot .v{font-size:26px;font-weight:800}' +
        '.re{margin:18px 40px 0;background:rgba(23,163,74,.07);border:1px solid rgba(23,163,74,.2);border-radius:10px;padding:13px 16px;font-size:13px;line-height:1.5}' +
        '.ft{margin:22px 40px 0;padding:18px 0 34px;border-top:1px solid #EFF1F3;display:flex;justify-content:space-between;gap:16px;font-size:12px;color:#5B6470;flex-wrap:wrap}' +
        '.ft a{color:var(--acc);text-decoration:none;font-weight:700}' +
        '.act{text-align:center;padding:4px 0 30px;display:flex;gap:10px;justify-content:center;flex-wrap:wrap}.btn{font-family:inherit;cursor:pointer;background:var(--acc);color:#fff;font-weight:800;font-size:14px;padding:13px 28px;border-radius:10px;border:1.5px solid var(--acc)}.btn.alt{background:#fff;color:var(--acc)}' +
        '@media print{body{background:#fff}.sheet{box-shadow:none;margin:0;border-radius:0;max-width:none}.noprint{display:none!important}@page{margin:14mm}}' +
        '</style></head><body><div class="sheet"><div class="bar"></div>' +
        '<div class="head">' + logo + '<div class="m">' + brand + '<br>' + dateStr + '</div></div>' +
        '<div class="ey">Your instant quote</div><h1>' + (meta.title || 'Product') + '</h1>' +
        (absUrl ? '<div class="sub">' + absUrl + '</div>' : '') +
        '<table>' + rows + pr + '</table>' +
        '<div class="tot"><span class="l">Total (inc GST)</span><span class="v">' + money(p.total) + '</span></div>' +
        '<div class="re"><b>No payment required to proceed.</b> A designer will finalise your artwork — we only invoice once you approve the final design.</div>' +
        '<div class="ft"><div>' + brand + (meta.abn ? ' · ABN ' + meta.abn : '') + '</div><div>' + (meta.phone ? meta.phone + ' · ' : '') + (meta.email ? '<a href="mailto:' + meta.email + '">' + meta.email + '</a>' : '') + '</div></div>' +
        '</div><div class="act noprint">' +
        '<button class="btn" onclick="window.print()">Save as PDF / Print</button>' +
        '<button class="btn alt" onclick="pcDl()">⬇ Download</button>' +
        '</div>' +
        '<script>function pcDl(){var h=\'<!doctype html>\'+document.documentElement.outerHTML;' +
        'var b=new Blob([h],{type:\'text/html\'});var u=URL.createObjectURL(b);' +
        'var a=document.createElement(\'a\');a.href=u;a.download=' + JSON.stringify(dlfile) + ';' +
        'document.body.appendChild(a);a.click();a.remove();' +
        'setTimeout(function(){URL.revokeObjectURL(u)},1500);}</script>' +
        '</body></html>';
    }
    function openQuote() {
      var w = window.open('', '_blank');
      if (w) { w.document.open(); w.document.write(quoteHTML()); w.document.close(); return; }
      // popup blocked -> fall back to downloading the file
      var blob = new Blob([quoteHTML()], { type: 'text/html' });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a'); a.href = url;
      a.download = 'Promocolour-quote-' + ((meta.title || 'product').replace(/[^a-z0-9]+/gi, '-').toLowerCase()) + '.html';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
    }

    /* ---- add to cart, then either checkout or open the cart ---- */
    function addToCart(btn, restoreText, onDone) {
      var p = pricing();
      btn.disabled = true; btn.textContent = 'Adding…';
      var props = {
        'Quantity': p.qty,
        'Discount tier': p.tier.pct ? (p.tier.pct + '% off (' + p.tier.min + '+)') : 'None',
        'Quoted unit price': money(p.discUnit),
        'Quote total (inc GST)': money(p.total),
        'Artwork method': artMethod || '—',
        'Send artwork later': $('[data-pw-later]') && $('[data-pw-later]').checked ? 'Yes' : 'No',
        'Speak with a designer': $('[data-pw-designer]') && $('[data-pw-designer]').checked ? 'Yes' : 'No'
      };
      // Merge any line-item properties injected into the form by UploadLift (e.g. the uploaded artwork file link)
      var form = $('[data-pw-form]');
      if (form) {
        form.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]').forEach(function (el) {
          var m = el.name.match(/^properties\[(.+)\]$/);
          if (m && el.value) props[m[1]] = el.value;
        });
      }
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: p.v.id, quantity: p.qty, properties: props })
      }).then(function (r) { return r.json(); })
        .then(function () { onDone(); })
        .catch(function () { btn.disabled = false; btn.textContent = restoreText; alert('Sorry, something went wrong adding to cart. Please try again.'); });
    }
    function openCart() {
      // open the cart drawer if the theme has one, otherwise fall back to the cart page
      var drawer = document.querySelector('cart-drawer, #CartDrawer, [data-cart-drawer]');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); }
      else if (drawer) { drawer.classList.add('is-open', 'active', 'animate'); document.body.classList.add('cart-open'); }
      else { window.location.href = '/cart'; }
    }

    /* ---- wire events ---- */
    $$('[data-pw-option]').forEach(function (s) { s.addEventListener('change', renderPrice); });
    $('[data-pw-qty]').addEventListener('input', renderPrice);
    $('[data-pw-qminus]').addEventListener('click', function () { var q = $('[data-pw-qty]'); q.value = Math.max(1, (parseInt(q.value, 10) || 1) - 1); renderPrice(); });
    $('[data-pw-qplus]').addEventListener('click', function () { var q = $('[data-pw-qty]'); q.value = (parseInt(q.value, 10) || 1) + 1; renderPrice(); });

    $$('[data-pw-uptab]').forEach(function (a) {
      a.addEventListener('click', function () {
        $$('[data-pw-uptab]').forEach(function (x) { x.classList.remove('is-active'); });
        a.classList.add('is-active');
        artMethod = a.getAttribute('data-pw-method');
        var t = $('[data-pw-drop-title]'), sub = $('[data-pw-drop-sub]');
        if (t) t.textContent = a.getAttribute('data-title');
        if (sub) sub.textContent = a.getAttribute('data-sub');
      });
    });


    $$('[data-pw-next]').forEach(function (b) { b.addEventListener('click', function () { goTo(parseInt(b.getAttribute('data-pw-next'), 10)); }); });
    $$('[data-pw-back]').forEach(function (b) { b.addEventListener('click', function () { goTo(parseInt(b.getAttribute('data-pw-back'), 10)); }); });
    $$('[data-pw-stepdot]').forEach(function (d) { d.addEventListener('click', function () { if (d.classList.contains('is-done')) goTo(parseInt(d.getAttribute('data-pw-stepdot'), 10)); }); });

    var dl = $('[data-pw-download]'); if (dl) dl.addEventListener('click', openQuote);

    var sb = $('[data-pw-submit]'); if (sb) sb.addEventListener('click', function () { addToCart(sb, 'Secure order now →', function () { window.location.href = '/checkout'; }); });
    var kb = $('[data-pw-keep]'); if (kb) kb.addEventListener('click', function () { addToCart(kb, 'Keep browsing', openCart); });

    /* ---- UploadLift integration ----
       UploadLift can't position into our hidden Step-3 panel, so it injects its widget at the top of
       the form. We relocate that widget into the Artwork step's .upload-lift mount. Hidden inputs
       (the file-link property) stay in the form root so they still submit with the cart. ---- */
    var pwForm = $('[data-pw-form]');
    if (pwForm) pwForm.addEventListener('submit', function (e) { e.preventDefault(); });
    var upMount = $('[data-pw-upload]');
    if (pwForm && upMount && window.MutationObserver) {
      // UploadLift injects its widget at the top of the form (it can't target our hidden Step-3 mount).
      // Identify it by ITS OWN classes and relocate into Step 3 — independent of load order, so it works
      // whether UploadLift runs before or after this (deferred) script. The widget stays inside the form,
      // so its hidden file-link property still submits with the cart.
      var UP_SEL = '.upload-container, .cl-upload--wrapper';
      var relocate = function () {
        [].slice.call(pwForm.querySelectorAll(UP_SEL)).forEach(function (w) {
          if (!upMount.contains(w)) { upMount.appendChild(w); } // move it (or skip if already relocated)
        });
        if (upMount.querySelector(UP_SEL)) {
          $$('[data-pw-fallback]', upMount).forEach(function (el) { el.style.display = 'none'; });
          upMount.classList.add('is-uploadlift');
        }
      };
      new MutationObserver(relocate).observe(pwForm, { childList: true });
      relocate();
    }

    /* ---- gallery thumbs ---- */
    $$('[data-pw-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var img = $('[data-pw-main-img]'); if (img) img.src = t.getAttribute('data-src');
        $$('[data-pw-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    /* ---- sticky get-quote bar ---- */
    var sticky = $('[data-pw-sticky]');
    if (sticky) {
      var stickyCta = $('[data-pw-sticky-cta]');
      if (stickyCta) stickyCta.addEventListener('click', function () { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      var anchor = $('.pc-pw__card') || $('.pc-pw__buy') || root;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          sticky.hidden = entries[0].isIntersecting; // show only once the wizard is scrolled out of view
        }, { threshold: 0 }).observe(anchor);
      }
    }

    renderPrice();
  }

  function boot() { Array.prototype.slice.call(document.querySelectorAll('[data-pc-wizard]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
